import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import { getWantAdById } from "@/services/v2/wantAdService";

const BUYER_SPECIFIC_FIELDS = [
  "wantAdId",
  "id",
  "uuid",
  "slug",
  "isPublished",
  "isEdit",
  "userId",
  "clientId",
  "clientName",
  "clientData",
  "isFilledByClient",
  "buyersAgreementSigned",
  "videoUrl",
  "thumbnailImgUrl",
  "s3ImageFolder",
  "mapImg",
  "startDate",
  "endDate",
  "purchaseType",
  "prchTypeId",
  "pFinance",
  "creditScore",
  "isPreApprLoan",
  "agreePreApprovedLoan",
  "finTypeId",
  // The API insert writes these verbatim, so a copy would inherit the source
  // ad's client-form code and review state; the rest is per-buyer or derived.
  "client_Want_ad_Id",
  "isReadyToReview",
  "adDesc",
  "clientFirstName",
  "clientLastName",
  "isAgentAsSeller",
  "publishedOn",
  "createdOn",
  "isArchived",
  "introCount",
  "matchStatus",
  "isFavourite",
  "isMarketRestricted",
  "isGitchaAvailable",
  "blsReference",
];

export const startFromCopy = (wantAd) =>
  wantAd ? { ..._.omit(wantAd, BUYER_SPECIFIC_FIELDS), isEdit: false } : null;

export const startFromId = (search) => {
  const raw = new URLSearchParams(search || "").get("startFrom");
  return raw && /^\d+$/.test(raw) ? raw : null;
};

export const useStartFromWantAd = (wantAdId) =>
  useQuery({
    queryKey: ["startFromWantAd", wantAdId],
    queryFn: async () => {
      const response = await getWantAdById(wantAdId);
      const result = _.get(response, "result", null);
      return response?.errorCode === 0 && result ? startFromCopy(result) : null;
    },
    enabled: !!wantAdId,
    staleTime: 0,
    retry: false,
  });
